import { Actions, createStore } from '@bpd-library/utilities';

import { initialiseAlert } from './utilities/alert-utilitites';

export interface AlertItem {
    text: string | Text;
    type?: 'success' | 'error' | 'info';
    isRendered: boolean;
}

export interface AlertState {
    alerts: AlertItem[];
}

type AlertStoreAction = 'addAlert';

const initialState: AlertState = {
    alerts: [],
};

const actions: Actions<AlertStoreAction, AlertState> = {
    addAlert: (
        state: AlertState,
        payload: { text: string | Text; type?: 'success' | 'error' | 'info' },
    ) => {
        // Make sure alerts are loaded and added to the body
        initialiseAlert();

        // Add alert string
        state.alerts = [
            ...state.alerts,
            { text: payload.text, type: payload.type, isRendered: false },
        ];

        return state;
    },
};

export const alertStore = createStore<AlertState, AlertStoreAction>({
    initialState,
    actions,
});

export const addAlert = (text: string | Text, type?: 'success' | 'error' | 'info') => {
    alertStore.dispatch('addAlert', { text, type });
};
